/**
 * Cleanup URL pathname removing doubleslashes and joining relative paths.
 */
export function resolvePathname(...pathnameParts: string[]) {
    let out = '/';
    for (const part of pathnameParts) {
        if (part.startsWith('/')) {
            out = '/' + part + '/';
        } else {
            out += part + '/';
        }
    }
    return '/' + out.split('/').filter(v => v && v !== '.').join('/');
}
